import { IOption } from "Dashboard/domain/IOption";
import { useEffect, useState } from "react";
import { hrService } from "../services/hr.services";

export function useEmployeeOptions() {
  const [options, setOptions] = useState<IOption[]>([]);

  useEffect(() => {
    async function getEmployees() {
      const employees = await hrService.getAllEmployees();
      const op = employees.map((employee) => {
        return {
          label: employee.employeeName,
          value: employee.employeeId,
        };
      });
      setOptions(op);
    }

    try {
      getEmployees();
    } catch (err) {
      console.log(err);
    }
  }, []);

  return options;
}
